module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui mini modal"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('form', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "required field"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.member.name),
      expression: "member.name"
    }],
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.member.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.member, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75bc9d86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/memberDialog.vue
// module id = 249
// module chunks = 1